export const cardDesignTypeConstants = {
  NORMAL: 'card_design',
  PERSONAL: 'personal_card_design'
}
